module.exports = __webpack_public_path__ + "static/media/errorImage.ac5dac7c.png";